export default __webpack_public_path__ + "static/media/GM_Bowl_Haze.b3d45943.png";